
<div class="saved-filters">
  <saved-options-dropdown
    label="Saved Searches"
    :options="savedFilters"
    :save-disabled="!isFiltering || maxReached"
    :allow-deselect="allowDeselect"
    :hide-save="hideSave"
    :align="align"
    @edit="editSavedFilter"
    @delete="deleteSavedFilter"
    @select="selectSavedFilter"
    @save="showModal = true"
  />

  <save-filter-modal
    :type="type"
    :open="showModal"
    :query="query"
    :filters="filters"
    :editing="editing"
    @close="closeModal"
  />
</div>
